const state = {
  allContracts: [],
  allContractSteps: [],
  allContractStatus: [],
  allContractActions: [],
};

const getters = {
  allContracts(state) {
    return state.allContracts;
  },
  allContractSteps(state) {
    return state.allContractSteps;
  },
  allContractStatus(state) {
    return state.allContractStatus;
  },
  allContractActions(state) {
    return state.allContractActions;
  },
};

const mutations = {
  SET_ALL_CONTRACTS: (state, allContracts) => {
    state.allContracts = allContracts;
  },
  SET_ALL_CONTRACT_STEPS: (state, allContractSteps) => {
    state.allContractSteps = allContractSteps;
  },
  SET_ALL_CONTRACT_STATUS: (state, allContractStatus) => {
    state.allContractStatus = allContractStatus;
  },
  SET_ALL_CONTRACT_ACTIONS: (state, allContractActions) => {
    state.allContractActions = allContractActions;
  },
};

const actions = {
  setAllContracts({ commit }, data) {
    commit("SET_ALL_CONTRACTS", data);
  },
  setAllContractSteps({ commit }, data) {
    commit("SET_ALL_CONTRACT_STEPS", data);
  },
  setAllContractStatus({ commit }, data) {
    commit("SET_ALL_CONTRACT_STATUS", data);
  },
  setAllContractActions({ commit }, data) {
    commit("SET_ALL_CONTRACT_ACTIONS", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
